import { ModalityPage } from "./ModalityPage";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

export class ModalityPageManager extends TimeSeriesPageManager<ModalityPage> {
    getPageMaker(): () => ModalityPage { 
        return () => new ModalityPage()
    }
}